export const environment = {
  version: 'V1.0.28',
  basePath: 'https://einvoiceapidev.azurewebsites.net',
  siteKey: '0x4AAAAAAAgGY8C8qN9MQNrc'
}
